import { ReactNode } from "react";

import AdminPage from "../Pages/Admin";
import AdminCreateTemplate from "../Pages/Admin/CreateTemplate";

export interface IzbaAdminRoute {
  path: string;
  element: ReactNode;
  label?: string;
}

const izbaAdminRoutes: IzbaAdminRoute[] = [
  {
    path: "/",
    element: <AdminPage />,
    label: "Home",
  },
  {
    path: "/izba-admin",
    element: <AdminPage />,
    label: "Home",
  },
  {
    path: "/izba-admin/create-template",
    element: <AdminCreateTemplate />,
    label: "Create Template",
  },
];

export default izbaAdminRoutes;
